import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=425ec687&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=425ec687&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ec687",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425ec687')) {
      api.createRecord('425ec687', component.options)
    } else {
      api.reload('425ec687', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=425ec687&scoped=true&", function () {
      api.rerender('425ec687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/menu/menu-item.vue"
export default component.exports